import { getEInvoiceConfiguration, updateEInvoiceConfiguration } from "@/api/action-defines/e-invoice-management";
import { showToast } from '@/@core/utils/utils';
import { EInvoiceConfigurationCode } from "@/@core/data/enum/menuCode";
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      previewData: [
        {
          id: "1e0db09a-1111-4a6a-993d-e9da84f9839d",
          ItemName: "Dịch vụ 1",
          GroupItemId: '1',
          GroupItemName: 'Nhóm dịch vụ 1',
          Unit: "Đơn vị 1",
          Quantity: 1,
          UnitPrice: 1000000,
          DiscountAmount: 100000,
          Charges: 10,
          ChargesAmount: 100000,
          Tax: 10,
          TaxAmount: 100000,
          SpecialTax: 5,
          SpecialTaxAmount: 5000,
          TotalAmount: 80000,
        },
        {
          id: "4h0ac09a-0941-1a8a-993d-e9da24f9839d",
          ItemName: "Dịch vụ 2",
          GroupItemId: '1',
          GroupItemName: 'Nhóm dịch vụ 2',
          Unit: "Đơn vị 2",
          Quantity: 2,
          UnitPrice: 100000,
          DiscountAmount: 10000,
          Charges: 0,
          ChargesAmount: 0,
          Tax: 10,
          TaxAmount: 10000,
          SpecialTax: 5,
          SpecialTaxAmount: 5000,
          TotalAmount: 80000,
        },
      ],
      invoiceTypes: [],
      defaultPaymentList: [],
      discountTypes: [],
      chargeOptions: [],
      taxOptions: [],
      // Mỗi sản phẩm kết nối có một cấu hình riêng phía BE (cột ConnectedProduct). Đồng bộ một chiều:
      // lưu EZONE ⇒ BE set DEFAULT y hệt EZONE; lưu DEFAULT ⇒ EZONE giữ nguyên
      connectedProduct: 'DEFAULT',
      connectedProductList: [
        { text: 'Hệ thống mặc định', value: 'DEFAULT' },
        { text: 'Hệ thống EzOne', value: 'EZONE' },
      ],
      // Draft/Official khớp với InvoiceCreateStatus phía BE. 'Internal' chỉ là giá trị UI:
      // chọn nó ⇒ IsInternalInvoice = true (BE ưu tiên cờ này, chỉ lưu nháp nội bộ, không gửi nhà cung cấp)
      invoiceCreateStatusList: [
        { text: 'Nháp', value: 'Draft' },
        { text: 'Chính thức', value: 'Official' },
        { text: 'Nháp nội bộ', value: 'Internal' },
      ],
      isPublishList: [
        { text: 'common_yes', value: true },
        { text: 'common_no', value: false },
      ],
      // Giá trị khớp với enum EInvoiceType phía BE
      typeEInvoiceList: [
        { text: 'Máy tính tiền (không ký HSM)', value: 1 },
        { text: 'Hóa đơn điện tử thường (ký HSM)', value: 0 },
        { text: 'Máy tính tiền (ký HSM)', value: 4 },
      ],
      eInvoiceConfig: {},
    }
  },
  async created() {
    await this.getEInvoiceConfiguration();
  },
  computed: {
     ...mapGetters({
          $ls_CurrentSiteID: 'auth/currentSiteID',
          $lsAllowOperation: 'app/allowOperation',
        }),
    isBHInvoice() {
      return this.eInvoiceConfig.InvoiceType === 'BH_INVOICE';
    },
    isEzOneProduct() {
      return this.connectedProduct === 'EZONE';
    },
    showIsPublishOption() {
      return this.isEzOneProduct && this.selectedInvoiceCreateStatus === 'Official';
    },
    selectedInvoiceCreateStatus() {
      return this.eInvoiceConfig.IsInternalInvoice ? 'Internal' : this.eInvoiceConfig.InvoiceCreateStatus;
    }
  },
  watch: {
    'eInvoiceConfig.InvoiceCreateStatus': {
      handler(newValue) {
        // Không phát hành khi hóa đơn được tạo ở trạng thái nháp
        if (newValue !== 'Official') {
          this.eInvoiceConfig.IsPublish = false;
        }
      }
    },
    'eInvoiceConfig.InvoiceType': {
      handler(newValue) {
        if (newValue === 'BH_INVOICE') {
          // Set default values for BH_INVOICE type
          // KHÔNG ép DiscountOption: hóa đơn bán hàng / hộ kinh doanh được tự chọn cách hiển thị chiết khấu
          this.eInvoiceConfig.ChargeOption = 'SEPARATE_COLUMN';
          this.eInvoiceConfig.ShowChargePercent = true;
          this.eInvoiceConfig.ShowRepresentativeName = true;
          this.eInvoiceConfig.ShowTaxDetail = false;
          this.eInvoiceConfig.ShowTaxPercent = true;
          this.eInvoiceConfig.TaxOption = 'SEPARATE_COLUMN';
        }
      },
      immediate: true
    }
  },
  methods: {
    async changeConnectedProduct(product) {
      if (this.connectedProduct === product) return;
      this.connectedProduct = product;
      await this.getEInvoiceConfiguration();
    },
    async getEInvoiceConfiguration() {
      const product = this.connectedProduct;
      try {
        const res = await getEInvoiceConfiguration({ QueryParameters: { ConnectedProduct: product } });
        // Đổi sản phẩm liên tục thì bỏ response của sản phẩm cũ, tránh hiện/lưu nhầm cấu hình
        if (product !== this.connectedProduct) return;
        if (res.StatusCode === '200') {
          // Khai báo sẵn 3 key mới: Vue 2 không theo dõi được property thêm sau,
          // nên nếu API thiếu key thì dropdown sẽ không cập nhật
          this.eInvoiceConfig = {
            InvoiceCreateStatus: null,
            IsPublish: false,
            TypeEInvoice: null,
            IsInternalInvoice: false,
            ...res.Data.EInvoiceConfig,
          };
          if (this.eInvoiceConfig.RepresentativeName === 'DEFAULT_REPRESENTATIVE_NAME'){
            this.eInvoiceConfig.RepresentativeName = this.$t('DEFAULT_REPRESENTATIVE_NAME');
          }
          
          // Set default values for BH_INVOICE type
          // KHÔNG ép DiscountOption: giữ đúng giá trị đã lưu để màn hình khớp DB
          if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
            this.eInvoiceConfig.ChargeOption = 'SEPARATE_COLUMN';
            this.eInvoiceConfig.ShowChargePercent = true;
            this.eInvoiceConfig.ShowRepresentativeName = true;
            this.eInvoiceConfig.ShowTaxDetail = false;
            this.eInvoiceConfig.ShowTaxPercent = true;
            this.eInvoiceConfig.TaxOption = 'SEPARATE_COLUMN';
          }
          
          this.invoiceTypes = this.formatResponse(res.Data.InvoiceTypes);
          this.discountTypes = this.formatResponse(res.Data.DiscountTypes);
          this.defaultPaymentList = this.formatResponse(res.Data.PaymentMethods);
          this.chargeOptions = this.formatResponse(res.Data.ChargeOptions);
          this.taxOptions = this.formatResponse(res.Data.TaxOptions);
        }

      } catch (err) {
        console.log(err)
      }

    },
    selectInvoiceCreateStatus(value) {
      const isInternal = value === 'Internal';
      this.eInvoiceConfig.IsInternalInvoice = isInternal;
      // Nháp nội bộ lưu kèm Draft để BE validate hợp lệ và watcher tắt IsPublish
      this.eInvoiceConfig.InvoiceCreateStatus = isInternal ? 'Draft' : value;
    },
     isCanEditEInvoiceConfiguration() {
        return this.$lsAllowOperation(EInvoiceConfigurationCode.EDIT);
    },
    formatResponse(arr) {
      if (typeof arr !== 'object') return;
      if (arr.length === 0) return

      return arr.map(item => {
        return {
          text: item.Text,
          value: item.Value
        }
      })
    },
    async updateEInvoiceConfig() {
      if (this.eInvoiceConfig.RepresentativeName === ''){
        showToast('error', this.$t('representative_name_required'));
      }else{
        try {
          const res = await updateEInvoiceConfiguration({
            BodyData: { ...this.eInvoiceConfig, ConnectedProduct: this.connectedProduct }
          });
          if (res.StatusCode === '200') {
            showToast('success', this.$t(res.Messages));
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    formatMoney(number) {
      //Format 2000000 to 2.000.000
      return number.toLocaleString('en-US');
    },
    calculateFieldTotal(field) {
      const isValidField = this.previewData.every(item => field in item)
      if (!isValidField) {
        return 0;
      }
      return this.previewData.reduce((total, item) => total = total + item[field], 0);
    },
    calculateTotalWithCallBack(callback) {
      return this.previewData.reduce((total, item) => {
        total = total + callback(item);
        return total;
      }, 0)
    },
    calculateUnitPrice(item) {
      let result = item.UnitPrice;
      //Merge Discount to UnitPrice
      if (this.eInvoiceConfig.DiscountOption === 'ADD_TO_UNIT_PRICE') {
        result -= +item.DiscountAmount / +item.Quantity;
      }
      //Merge Charge to UnitPrice
      if (this.eInvoiceConfig.ChargeOption === 'ADD_TO_UNIT_PRICE') {
        result += +(this.calculateTotalBeforeTaxAndCharge(item) * item.Charges / 100) / +item.Quantity;
      }
      return result;
    },
    calculateChargeAmount(item) {
      return this.calculateTotalBeforeTaxAndCharge(item) * item.Charges / 100;
    },
    calculateTaxAmount(item) {
      if (!this.showTaxColumn() || !item.Tax || +item.Tax <= 0) {
        return 0;
      }

      let baseAmount = this.calculateTotalBeforeTax(item);

      console.log('itemsss:', item);
      console.log('Base Amountff:', baseAmount);

      let taxAmount = baseAmount * (+item.Tax / 100);


      console.log('Base taxAmountsss:', taxAmount);
      // Xử lý giảm thuế nếu là BH_INVOICE
      // if (this.isBHInvoice) {
      //   const reductionRate = 0.2;
      //   taxAmount = taxAmount * (1 - reductionRate);
      // }

      return taxAmount;
    },
    calculateTotalBeforeTaxAndCharge(item) {
      return +item.UnitPrice * +item.Quantity - +item.DiscountAmount;
    },
    
    calculateTotalBeforeTax(item) {
      let result = +this.calculateUnitPrice(item) * +item.Quantity;
      //Seperate Discount to a column
      if (this.eInvoiceConfig.DiscountOption === 'SEPARATE_COLUMN') {
        result = result - item.DiscountAmount;
      }
      // Only add charge amount if ChargeOption is not SEPARATE_ROW
      if ((this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN' ||
        this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN_AND_DISPLAY_IN_TOTAL') &&
        this.eInvoiceConfig.ChargeOption !== 'SEPARATE_ROW') {
        result = result + this.calculateChargeAmount(item);
      }
      return result;
    },
    
    calculateTotalAfterTax(item) {
      let result = this.calculateTotalBeforeTax(item);
      if (this.showTaxColumn() && this.eInvoiceConfig.InvoiceType !== 'SALES_INVOICE') {
        const taxAmount = this.calculateTaxAmount(item);
        if (this.isBHInvoice) {
          // Chỉ trừ phần thuế được giảm (20%)
          const taxReduction = this.calculateTaxReduction(item);
          result = result - taxReduction;
        } else {
          result = result + taxAmount;
        }
      }
      return result;
    },

    getDropdownText(key) {
      let result = '';
      switch (key) {
        case 'InvoiceType':
          result = this.invoiceTypes.find(option => option.value === this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'DefaultPayment':
          result = this.defaultPaymentList.find(option => option.value === this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'DiscountOption':
          result = this.discountTypes.find(option => option.value === this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'ChargeOption':
          result = this.chargeOptions.find(option => option.value === this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'TaxOption':
          result = this.taxOptions.find(option => option.value === this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'ConnectedProduct':
          // Không nằm trong eInvoiceConfig vì chỉ là state UI
          result = this.connectedProductList.find(option => option.value === this.connectedProduct)?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'InvoiceCreateStatus':
          result = this.invoiceCreateStatusList.find(option => option.value == this.selectedInvoiceCreateStatus)?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'IsPublish':
          result = this.isPublishList.find(option => option.value == this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        case 'TypeEInvoice':
          result = this.typeEInvoiceList.find(option => option.value == this.eInvoiceConfig[key])?.text ||
            this.$t('choose_one_option_to_display');
          break;
        default:
          break;
      }

      return this.$t(result);
    },

    showChargeColumn() {
      // Sửa để hiển thị cột phí cho cả SEPARATE_COLUMN và DISPLAY_IN_TOTAL
      return this.eInvoiceConfig.ChargeOption === 'SEPARATE_COLUMN' || 
            this.eInvoiceConfig.ChargeOption === 'DISPLAY_IN_TOTAL';
    },

    showTaxColumn() {
      return ((this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN' ||
        this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN_AND_DISPLAY_IN_TOTAL' ||
        this.eInvoiceConfig.TaxOption === 'DISPLAY_IN_TOTAL') &&
        this.eInvoiceConfig.InvoiceType !== 'SALES_INVOICE' &&
        this.eInvoiceConfig.InvoiceType !== 'BH_INVOICE');
    },

    showDiscountColumn() {
      return this.eInvoiceConfig.DiscountOption === 'SEPARATE_COLUMN';
    },

    checkVatInvoice() {
      return this.eInvoiceConfig.InvoiceType === 'VAT_INVOICE';
    },
    
    showChargePercentColumn() {
      return this.eInvoiceConfig.ShowChargePercent && this.showChargeColumn();
    },

    

    showTaxPercentColumn() {
      if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
        return false;
      }
      return this.eInvoiceConfig.ShowTaxPercent && this.showTaxColumn();
    },

    

    calculateTaxReduction(item) {
      if (!this.isBHInvoice) return 0;

      const baseAmount = this.calculateTotalBeforeTax(item);
      const reductionRate = 0.2; // 20% mặc định
      return baseAmount * (+item.Tax / 100) * reductionRate;
    },

    calculateTotalTaxReduction() {
      if (!this.isBHInvoice) return 0;
      return this.previewData.reduce((total, item) => {
        return total + this.calculateTaxReduction(item);
      }, 0);
    },

  },
}